import { brandStorage as localStorage } from '@/utils/brandSession';
import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Phone, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('hw_token')}` });

/** Pulsante click-to-call Voxloud.
 * Click: chiama subito con l'interno memorizzato (o apre la scelta al primo uso).
 * Click destro: cambia interno. */
export const ClickToCallButton = ({ number, className = '' }) => {
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(localStorage.getItem('hw_ctc_extension') || '');
  const [calling, setCalling] = useState(false);

  if (!number) return null;

  const doCall = async (ext) => {
    setCalling(true);
    try {
      const r = await axios.post(`${API}/cs-control/click-to-call`,
        { number, extension: ext }, { headers: authHeaders() });
      if (r.data.ok) {
        localStorage.setItem('hw_ctc_extension', ext);
        toast.success(`📞 Chiamata avviata: rispondi all'interno ${ext}, poi verrà composto ${r.data.contact}`);
        setOpen(false);
      } else {
        toast.error(r.data.error || 'Errore avvio chiamata');
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || e?.response?.data?.error || 'Errore avvio chiamata');
    }
    setCalling(false);
  };

  const openPicker = async () => {
    setOpen(true);
    try {
      const r = await axios.get(`${API}/cs-control/voxloud/users`, { headers: authHeaders() });
      setUsers(r.data.users || []);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Impossibile caricare gli interni Voxloud');
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();
    const saved = localStorage.getItem('hw_ctc_extension');
    if (saved) doCall(saved);
    else openPicker();
  };

  const handleContext = (e) => {
    e.preventDefault();
    e.stopPropagation();
    openPicker();
  };

  return (
    <>
      <button
        type="button"
        data-testid="click-to-call-btn"
        onClick={handleClick}
        onContextMenu={handleContext}
        title={`Chiama ${number} dal centralino (clic destro per cambiare interno)`}
        className={`inline-flex items-center justify-center h-6 w-6 rounded-full bg-emerald-100 text-emerald-700 hover:bg-emerald-200 transition-colors ${className}`}>
        {calling ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Phone className="h-3.5 w-3.5" />}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="ctc-extension-dialog">
          <DialogHeader>
            <DialogTitle className="text-base">Chiama {number}</DialogTitle>
          </DialogHeader>
          <p className="text-xs text-slate-500 -mt-2">Scegli il tuo interno: prima squilla il tuo telefono, poi viene composto il numero.</p>
          <select
            data-testid="ctc-extension-select"
            value={selected}
            onChange={e => setSelected(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg text-sm bg-white">
            <option value="">— Seleziona interno —</option>
            {users.map(u => (
              <option key={u.extension} value={u.extension}>
                {u.extension} — {u.name || 'Interno'}
              </option>
            ))}
          </select>
          <Button data-testid="ctc-call-btn" disabled={!selected || calling} onClick={() => doCall(selected)}>
            {calling ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Phone className="h-4 w-4 mr-1" />}
            Chiama ora
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ClickToCallButton;
